import { render, staticRenderFns } from "./HistoryBills.vue?vue&type=template&id=7b901c45&"
import script from "./HistoryBills.vue?vue&type=script&lang=js&"
export * from "./HistoryBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports